import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-employment-or-board-participation-form',
    templateUrl: './employment-or-board-participation-form.component.html',
})
export class EmploymentOrBoardParticipationFormComponent {
    @Input({ required: true }) form!: FormGroup;

    participationTypes = ['Launað starf', 'Atvinnustarfsemi', 'Stjórnarseta', 'Seta í fjárfestingarráði', 'Seta í hagsmunaráði'];
    memberRoles = ['Aðalmaður', 'Varamaður'];
}
